import { getAliyunInfo } from '@/api/index'
import createUuid from '@/utils/uuid'
import { getMd5, CompressorImg } from '@/utils/imgUpload'
import { OssRequset } from '@/pages/admin/modelAdmin/aliRequest'
import storageUtils from '@/utils/storageUtils'
import vueDraggable from 'vuedraggable'
import { notification } from 'ant-design-vue'

import { circleAliyunOss } from '@/mixin/getCircleAliyunOss'
export default {
  components: {
    vueDraggable
  },
  props: {
    accept: {
      type: String,
      default: 'image/*'
    },
    originPic: {
      type: [String, Array],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 1
    },
    isNeedPng: {
      type: Boolean,
      default: false
    },
    // 图片宽度
    imgW: {
      type: [String, Number],
      default: 0
    },
    // 图片高度
    imgH: {
      type: [String, Number],
      default: 0
    },
    // 图片高度
    minW: {
      type: [String, Number],
      default: 0
    },
    // 图片高度
    minH: {
      type: [String, Number],
      default: 0
    },
    // 是否固定宽高
    fixedSize: {
      type: Boolean,
      default: false
    },
    // 是否限定在有效图片区域内
    beyond: {
      type: Boolean,
      default: true
    },
    // 是否等比例
    equal: {
      type: Boolean,
      default: true
    },
    // 是否保存图片
    isSaveImg: {
      type: Boolean,
      default: false
    },
    // 是否上传图片
    isUploadImg: {
      type: Boolean,
      default: true
    },
    // 是否显示重新上传
    showReset: {
      type: Boolean,
      default: false
    },
    // 是否仅压缩
    isOnlyCompress: {
      type: Boolean,
      default: false
    },
    // 压缩最大尺寸
    compressMax: {
      type: Number,
      default: 0
    },
    prefixPath: {
      default: 'model/'
    },
    isNeedMosaic: {
      type: Boolean,
      default: false
    },
    // 是否需要压缩
    isNeedCompress: {
      type: Boolean,
      default: false
    },
    // 是否开启多图上传
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否走裁剪逻辑 这个组件会自动裁剪
    isClip: {
      type: Boolean,
      default: true
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否禁用拖拽
    isDrag: {
      type: Boolean,
      default: true
    },
    // 是否严格限制 尺寸  注意要严格限制尺寸 就一定要穿 图片限制的宽高
    isStrictRestrictions: {
      type: Boolean,
      default: false
    },
    // 是否需要转webp
    isNeedToWebp: {
      type: Boolean,
      default: true
    },
    // f038
    uploadType: {
      type: String,
      default: ''
    }
  },
  mixins: [circleAliyunOss],
  data() {
    return {
      viewImageIng: false,
      spinning: false,
      editIndex: '',
      showClipPopup: false,
      objX: 0,
      startX: 0,
      startY: 0,
      moveBaseNum: 0,
      scale: 1,
      imgStr: '',
      fileList: [],
      isLoad: false,
      resize: false,
      showCover: false,
      user: {},
      coverStyle: {
        W: 0,
        H: 0,
        X: 0,
        Y: 0,
        minW: 0,
        minH: 0,
        maxW: 0,
        maxH: 0
      },
      clipBox: {},
      rangeCoords: {
        minX: 0,
        minY: 0,
        maxX: 3000,
        maxY: 3000
      },
      imgPos: {},

      // 马赛克相关
      setMosaicIng: false,
      currentMosaicImg: '',
      currentMosaicImgDom: null,
      mosaicIcon: {
        mosaic: {
          name: '马赛克',
          id: 'mosaic',
          w: 20,
          h: 20,
          url:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAD9JREFUOE/tk7EJAEAMApPJs5qZzJ9AsMyD1mJxeE2SZQSA0arqDEpOYSjRfHCbmbFM2V3PlAxKTmGoTTl/mwenU23jMnQymwAAAABJRU5ErkJggg=='
        }
      },
      MosaicCtx: null,
      MosaicObj: {},
      currentMosaic: {},
      allMosaicList: [],
      viewIndex: 0,
      recoverMosaicList: [],
      LastMosaicList: {
        uuid: '',
        name: '',
        scaling: 1,
        isDel: false,
        pos: []
      },
      continuousDraw: false,
      FillObj: [],
      isParticle: false,
      bucket: '',
      fileSizes: [],
      // 一次选择上传的数量
      uploadNums: 0,
      // 图片加载失败记录
      imgLoadErrors: {}
    }
  },
  watch: {
    showClipPopup: {
      deep: true,
      handler(o) {
        this.showCover = false
        if (o) {
          this.$nextTick(() => {
            this.$el.querySelector('.file-btn').value = ''
            setTimeout(() => {
              this.handleOpen()
            }, 300)
          })
        } else {
          this.revisePos(0, 0)
          this.removeEventMove()
          this.$emit('close')
        }
      }
    }
    // originPic(n) {
    //   if (n) {
    //     this.picInit()
    //   }
    // }
  },
  beforeDestroy() {
    this.removeEventMove()
  },
  computed: {
    getCoverStyle() {
      return this.coverStyle
    }
  },
  mounted() {
    this.picInit()
    this.user = storageUtils.getUser()
  },
  methods: {
    picInit() {
      this.imgLoadErrors = {}
      if (Array.isArray(this.originPic) && this.originPic.length) {
        this.fileList = [
          ...this.originPic.slice(0, this.maxLength).map(v => {
            if (Object.prototype.toString.call(v) === '[object Object]') {
              v.opacity = 1
            }
            return v
          })
        ]
      } else {
        this.fileList = []
      }
    },
    handleImgDel(i) {
      this.fileList.splice(i, 1)
      this.fileSizes.splice(i, 1)
      this.imgLoadErrors = {}
      this.$emit('delete', i)
    },
    // 图片加载失败处理
    handleImgError(i) {
      this.$set(this.imgLoadErrors, i, true)
    },
    handleImgView(i) {
      this.viewIndex = i
      this.viewImageIng = true
    },
    handleViewIndex(n) {
      let index = this.viewIndex + n
      if (index < 0) {
        index = this.fileList.slice(0, this.maxLength).length - 1
      }
      if (index > this.fileList.slice(0, this.maxLength).length - 1) {
        index = 0
      }

      this.viewIndex = index
    },
    // 设置可移动区间
    initConetntSize(resetPos) {
      // 裁剪展示区大小

      // 图片大小
      this.imgPos = this.PosAndSize('.clip-img')

      // 预设裁剪区为边长等于图片最高值的正方形

      let leftStart = 0
      let leftEnd = this.clipBox.W - this.coverStyle.W
      let topStart = 0
      let topEnd = this.clipBox.H - this.coverStyle.H

      // 限制不可超出图片有效区
      if (this.beyond) {
        leftStart = this.imgPos.X
        leftEnd = leftEnd - (this.clipBox.W - this.imgPos.W) / 2
        topStart = this.imgPos.Y
        topEnd = topEnd - (this.clipBox.H - this.imgPos.H) / 2
      }

      // 可移动区大小
      this.rangeCoords.minX = leftStart
      this.rangeCoords.maxX = leftEnd
      this.rangeCoords.minY = topStart
      this.rangeCoords.maxY = topEnd

      // 调用计算后是否重新设置裁剪框位置
      !resetPos ||
        this.revisePos(
          (this.clipBox.W - this.coverStyle.W) / 2,
          (this.clipBox.H - this.coverStyle.H) / 2
        )
      this.showCover = true
    },

    // 显示动画完成后计算
    handleOpen() {
      let coverW = this.imgW
      let coverH = this.imgH
      this.imgPos = this.PosAndSize('.clip-img')

      // 限制在有效图片区
      if (this.beyond) {
        // 去掉当尺寸超出后才“贴边”的条件，选择图片后若限制在有效区内则自动“贴边”
        // if (coverW > this.imgPos.W || coverH > this.imgPos.H) {
        this.scale = Math.min(this.imgPos.W / coverW, this.imgPos.H / coverH)
        coverW = this.imgW * this.scale
        coverH = this.imgH * this.scale
        // }
        coverW = coverW > this.imgPos.W ? this.imgPos.W : coverW
        coverH = coverH > this.imgPos.H ? this.imgPos.H : coverH
      }

      coverW = coverW < 10 ? 10 : coverW
      coverH = coverH < 10 ? 10 : coverH
      this.coverStyle.W = coverW
      this.coverStyle.H = coverH
      this.rangeCoords.minY = this.imgPos.Y
      this.rangeCoords.minX = this.imgPos.X
      this.clipBox = this.PosAndSize('.clip-box_content')
      this.initConetntSize(true)
      this.addEventMove()
    },

    // 编辑裁剪图片
    handleOpenClip(imgUrl, editIndex = false) {
      this.setMosaicIng = false
      if (this.imgH / this.imgW >= 10 || this.imgW / this.imgH <= 0.1) {
        this.$message.error('组件调用长宽比过大，请调整')
        return
      }
      const _this = this
      window.URL = window.URL || window.webkitURL
      const xhr = new XMLHttpRequest()
      xhr.open('get', imgUrl, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response
          const oFileReader = new FileReader()
          oFileReader.onload = async e => {
            const base64 = e.target.result
            _this.imgStr = base64
            _this.showClipPopup = true

            if (editIndex !== false) {
              _this.editIndex = editIndex
            }
          }
          oFileReader.readAsDataURL(blob)
        }
      }
      xhr.send()
    },

    // 选择文件
    handleOpenFile() {
      this.$el.querySelector('.file-btn').click()
    },
    // 选择文件
    changeFile(e) {
      this.setMosaicIng = false
      if (this.imgH / this.imgW >= 10 || this.imgW / this.imgH <= 0.1) {
        this.$message.error('组件调用长宽比过大(比例超过10)，请调整')
        return
      }
      if (e.target.files.length) {
        if (window.FileReader) {
          const filesList = e.target.files
          for (let i = 0; i < filesList.length; i++) {
            if (this.maxLength < i + 1 + this.fileList.length) {
              this.$message.error(`最多上传${this.maxLength}张图片`)
              break
            }
            const file = filesList[i]
            this.initUploadImg(file)
          }
        } else {
          this.$message.error('浏览器版本过低，请升级浏览器')
        }
      }
    },
    async initUploadImg(file) {
      this.uploadNums++
      const IMAGE_SIZE = 1024 * 1024 * 10
      // 阿里云图片转webp最大支持20M，大于20M之后转换，图片无法预览
      const limitSize = 20 * 1024 * 1024
      const GIF_SIZE = 10 * 1024 * 1024
      const picSize = file.size
      if (picSize > 500 * 1024) {
        // this.$message.warn('图片超过500K，建议优化下（压缩）再上传')
        notification.open({
          message: '提示',
          icon: <a-icon type="smile" style="color: #faad14;" />,
          description(h) {
            return (
              <div>
                <p>
                  图片超过 <b>500K</b>，建议优化（压缩）后再上传。
                </p>
                <p>推荐的压缩与格式转换网站：</p>
                <ul style="padding-left: 20px;">
                  <li>
                    👉
                    <a
                      href="https://tinify.cn/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      熊猫压缩（Tinify）
                    </a>
                  </li>
                  <li>
                    👉
                    <a
                      href="https://squoosh.app/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      图片格式转换（Squoosh）
                    </a>
                  </li>
                </ul>
                <p>
                  建议先压缩再转成 <b>WebP</b> 格式再上传。
                </p>
                <p style="color: #faad14;">
                  优化后的图片可显著提升页面加载速度和用户体验
                </p>
              </div>
            )
          },
          duration: 3.5
        })
      }
      if (picSize > limitSize) {
        return this.$message.error('图片超过20M，优化下（压缩）再上传')
      }
      const picType = file.type
      // gif 图大于10M，开始压缩
      if (picType === 'image/gif' && picSize > GIF_SIZE && this.isNeedToWebp) {
        file = await CompressorImg(file)
      }
      // 普通图片大于10K，开始压缩
      if (
        picType !== 'image/gif' &&
        picSize > IMAGE_SIZE &&
        // picSize < limitSize &&
        this.isNeedToWebp
      ) {
        file = await CompressorImg(file)
      }
      const reader = new FileReader()
      reader.readAsDataURL(file)
      this.showClipPopup = false
      reader.onerror = () => {
        this.spinning = false
        this.uploadNums = 0
        this.$message.error('图片读取失败，请重试')
        this.$emit(
          'error',
          new Error('Failed to read the image with FileReader.')
        )
      }
      reader.onload = async evt => {
        this.imgStr = evt.target.result
        this.$emit('startLoad')
        const Img = new Image()
        Img.src = this.imgStr
        Img.onerror = () => {
          this.spinning = false
          this.uploadNums = 0
          this.$message.error(
            '图片加载失败，可能图片已损坏或格式不支持，请更换图片重试'
          )
          this.$emit('error', new Error('Failed to load the compressed image.'))
        }
        Img.onload = () => {
          const { width, height } = Img
          if (width >= 16383 || height >= 16383) {
            return this.$message.error(
              '阿里云限制上传图片尺寸超过16383px的图片（webp格式），请优化'
            )
          }
          let isMinW = this.minW && width < this.minW
          let isMinH = this.minH && height < this.minH
          // 是否走裁剪逻辑
          // 确定了不走裁剪 或者以前替换组件导致没传裁剪图片宽度的都走直接上传
          if (!this.isClip || !this.imgW) {
            this.uploadImg(file, {
              W: width,
              H: height
            })
            return
          }

          if (this.isStrictRestrictions && this.imgW && this.imgH) {
            if (width != this.imgW || height != this.imgH) {
              return this.$message.error(
                `请上传对应尺寸图片（宽度为${this.imgW}，高度为${this.imgH}）            `
              )
            }
          }

          // 如果不需要压缩则只判断尺寸是否相符，不相符的尺寸不可上传
          if (!this.isNeedCompress) {
            let w = this.imgW || this.minW
            let h = this.imgH || this.minH
            let isEqual = Math.abs(w / h - width / height) > 0.01
            if (!h && width !== w) {
              return this.$message.error(
                `请上传标准尺寸图片（宽度为${w}，高度自适应）            `
              )
            }
            if (h && isEqual && w) {
              let scale = +(h / w).toFixed(2)
              this.$message.error(
                `请上传标准尺寸图片（${w}*${h}, 宽高比为1:${scale}）`
              )
              this.showClipPopup = false
              return false
            } else {
              this.uploadImg(file, { W: width, H: height })
            }
            return
          }

          // 比例不同
          let isEqual = this.minW / this.minH !== width / height

          // 添加逻辑、若选择图片比例与限制尺寸比例相同且无需打马赛克则保持原图尺寸
          if (
            this.imgW &&
            this.imgH &&
            this.imgH / this.imgW === height / width &&
            !this.isNeedMosaic &&
            !this.minW
          ) {
            let params = {
              cw: width,
              ch: height,
              imgW: width,
              imgH: height,
              imgX: 0,
              imgY: 0,
              imgUrl: this.imgStr
            }
            this.Draw(params)
              .then(res => {
                this.downImg(res)
              })
              .catch(() => {
                this.$emit('error', 2)
              })
            return
          }

          let onlyCompress =
            this.imgW &&
            this.imgH &&
            this.imgW === width &&
            this.imgH === height
          if (this.isOnlyCompress || onlyCompress) {
            if (isMinW || isMinH || (isEqual && (this.minW || this.minH))) {
              let scale = +(this.minH / this.minW).toFixed(2)
              this.$message.error(
                `请上传标准尺寸图片（最小尺寸为${this.minW}*${this.minH}, 宽高比为1:${scale}）`
              )
              this.showClipPopup = false
              return false
            }
            this.spinning = true
            const params = {
              cw: width,
              ch: height,
              imgW: width,
              imgH: height,
              imgX: 0,
              imgY: 0,
              imgUrl: this.imgStr
            }
            this.Draw(params)
              .then(res => {
                this.downImg(res)
              })
              .catch(() => {
                this.$emit('error', 2)
              })
          } else {
            this.showClipPopup = true
          }
        }
        this.$el.querySelector('.file-btn').value = ''
      }
    },
    // 获取DOM位置及尺寸
    PosAndSize(targetString) {
      const center = this.$el.querySelector(targetString)
      const W = Math.ceil(center.clientWidth)
      const H = Math.ceil(center.clientHeight)
      const X = Math.ceil(center.offsetLeft)
      const Y = Math.ceil(center.offsetTop)
      return {
        W,
        H,
        X,
        Y
      }
    },

    // 计算“裁剪区”尺寸及位置
    clac() {
      // 基础数值
      const boxLeft = this.$el.querySelector('.shade_lef')
      const boxTop = this.$el.querySelector('.shade_top')
      const boxRight = this.$el.querySelector('.shade_right')
      const boxBottom = this.$el.querySelector('.shade_bottom')
      const OW = this.clipBox.W
      const OH = this.clipBox.H
      const { W, H, X, Y } = this.coverStyle
      boxLeft.style.top = Y + 'px'
      boxLeft.style.width = X + 'px'
      boxLeft.style.height = H + 'px'
      boxTop.style.height = Y + 'px'
      boxRight.style.top = Y + 'px'
      boxRight.style.width = OW - X - W + 'px'
      boxRight.style.height = H + 'px'
      boxBottom.style.height = OH - Y - H + 'px'
    },

    // 位置修正
    revisePos(left, top) {
      // 限制不允许超过边界
      left = left < this.rangeCoords.minX ? this.rangeCoords.minX : left
      left = left > this.rangeCoords.maxX ? this.rangeCoords.maxX : left
      top = top < this.rangeCoords.minY ? this.rangeCoords.minY : top
      top = top > this.rangeCoords.maxY ? this.rangeCoords.maxY : top

      this.coverStyle.X = left
      this.coverStyle.Y = top
      // 将值设置到"透明"区域
      this.$nextTick(() => {
        this.clac()
      })
    },

    // 裁剪区域点击
    CenterBoxMouseDown(e) {
      this.boxMove = true
      this.startX = e.pageX
      this.startY = e.pageY
      this.objX = this.coverStyle.X
      this.objY = this.coverStyle.Y
    },

    // 裁剪区域移动
    CenterBoxMouseMove(e) {
      //   如果判断移动不为真,则返回
      if (!this.boxMove) return

      // 获取实时位置
      const left = this.objX - this.startX + e.pageX
      const top = this.objY - this.startY + e.pageY
      this.revisePos(left, top)
    },

    // 控制器点击
    CenterControlMouseDown(e) {
      e.stopPropagation()
      if (this.fixedSize) return
      //  取值，不缀叙
      this.resize = true
      this.startX = e.pageX
      this.startY = e.pageY
      this.startW = this.coverStyle.W
      this.startH = this.coverStyle.H
      this.moveBaseNum = 0
    },

    // 控制器移动
    async CenterControlMouseMove(e) {
      if (!this.resize) return
      // 获取基准值
      const { W, H } = this.clipBox

      const moveX = e.pageX - this.startX
      const moveY = e.pageY - this.startY

      const centerPos = this.PosAndSize('.center')

      // 限制逻辑
      // 最大尺寸默认为显示区 - 裁剪框位置
      let maxW = W - centerPos.X
      let maxH = H - centerPos.Y

      // 如果限制只允许在有效图片区, 最大尺寸为最小尺寸 + 图片尺寸 - 裁剪框位置
      if (this.beyond) {
        maxW = this.rangeCoords.minX + this.imgPos.W - centerPos.X
        maxH = this.rangeCoords.minY + this.imgPos.H - centerPos.Y
      }

      // 设置裁剪区大小
      const numW = this.startW + moveX
      let numH = this.startH + moveY

      // 固定比例
      if (this.equal) {
        const maxEqual = numW / this.imgW
        numH = this.imgH * maxEqual
      }

      // 当任意一边超出有效区后，中断计算，不做处理
      if (numW < 30 || numH < 30 || numW > maxW || numH > maxH) {
        console.log(numW < 30, numH < 30, numW > maxW, numH > maxH)
        return
      }

      this.coverStyle.W = numW
      this.coverStyle.H = numH
      await this.initConetntSize()
      this.clac()
    },

    // 添加文档事件
    DocumentEvent() {
      this.boxMove = false
      this.resize = false
    },

    // 绑定事件
    addEventMove() {
      this.$el
        .querySelector('.center_box')
        .addEventListener('mousedown', this.CenterBoxMouseDown)

      !this.$el.querySelector('.center_control') ||
        this.$el
          .querySelector('.center_control')
          .addEventListener('mousedown', this.CenterControlMouseDown)

      document.addEventListener('mousemove', this.CenterControlMouseMove)

      document.addEventListener('mouseup', this.DocumentEvent)

      document.addEventListener('mousemove', this.CenterBoxMouseMove)
    },

    // 解绑事件
    removeEventMove() {
      !this.$el.querySelector('.center_box') ||
        this.$el
          .querySelector('.center_box')
          .removeEventListener('mousedown', this.CenterBoxMouseDown)

      !this.$el.querySelector('.center_control') ||
        this.$el
          .querySelector('.center_control')
          .removeEventListener('mousedown', this.CenterControlMouseDown)

      !document ||
        document.removeEventListener('mousemove', this.CenterControlMouseMove)

      document.removeEventListener('mouseup', this.DocumentEvent)

      !document ||
        document.removeEventListener('mousemove', this.CenterBoxMouseMove)
    },

    // 画图
    // params:
    //    cw: canvas 宽度
    //    ch: canvas 高度
    //    imgW: 图片 宽度
    //    imgH 图片 宽度
    //    imgX: 图片x轴
    //    imgY: 图片y轴
    //    imgUrl: 图片地址
    Draw(params) {
      return new Promise((resolve, reject) => {
        let defaultParams = {
          cw: '',
          ch: '',
          imgW: '',
          imgH: '',
          imgX: '',
          imgY: '',
          imgUrl: this.imgStr
        }
        if (!params) {
          const { W, H, X, Y } = this.coverStyle
          const imgPos = this.PosAndSize('.clip-img')
          // 计算显示图与原图的缩放比，用于在原始分辨率下裁剪，避免图片模糊
          const img = new Image()
          img.src = this.imgStr
          const originW = img.naturalWidth || img.width
          const originH = img.naturalHeight || img.height
          // 显示图与原图的比率（displaySize / originalSize）
          const ratioW = originW > 0 ? imgPos.W / originW : 1
          const ratioH = originH > 0 ? imgPos.H / originH : 1
          // 保存原图尺寸供其他方法使用
          this.originalImgSize = { W: originW, H: originH }
          defaultParams = {
            // canvas 尺寸按比率放大到原图分辨率，防止导出图片模糊
            cw: Math.round(W / ratioW),
            ch: Math.round(H / ratioH),
            imgW: Math.round(imgPos.W / ratioW),
            imgH: Math.round(imgPos.H / ratioH),
            imgX: Math.round((-X + imgPos.X) / ratioW),
            imgY: Math.round((-Y + imgPos.Y) / ratioH),
            imgUrl: this.imgStr
          }
          params = defaultParams
        } else {
          Object.keys(defaultParams)
            .filter(v => !Object.keys(params).includes(v))
            .forEach(v => {
              reject(new Error(`${v}必需`))
            })
        }

        const canvas = document.createElement('canvas')
        const { cw, ch, imgUrl, imgX, imgY, imgW, imgH } = params
        canvas.width = cw
        canvas.height = ch
        const ctx = canvas.getContext('2d')
        const Img = new Image()
        Img.src = imgUrl
        Img.onload = () => {
          if (!this.isNeedPng) {
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
          }
          ctx.drawImage(Img, imgX, imgY, imgW, imgH)
          const imgData = canvas.toDataURL(
            this.isNeedPng ? 'png' : 'image/webp',
            1
          )
          resolve({ W: cw, H: ch, url: imgData })
        }
        Img.onerror = () => {
          reject(new Error('图片加载失败'))
        }
      })
    },

    // 生成图片并下载
    DrawAndDown() {
      let params = ''
      if (this.setMosaicIng) {
        const { W, H } = this.PosAndSize('#mosaic-canvas')
        const canvas = this.$el.querySelector('#mosaic-canvas')
        params = {
          cw: W,
          ch: H,
          imgW: W,
          imgH: H,
          imgX: 0,
          imgY: 0,
          imgUrl: canvas.toDataURL(this.isNeedPng ? 'png' : 'image/jpeg', 1)
        }
      }

      this.Draw(params)
        .then(res => {
          this.showClipPopup = false
          this.setMosaicIng = false
          this.downImg(res)
        })
        .catch(e => {
          this.$emit('error', e)
        })
    },

    // 图片下载
    downImg(e) {
      // 图片导出为 png 格式
      const type = 'png'
      const canvas = document.createElement('canvas')
      let { W, H, url } = e
      if (!this.isOnlyCompress && this.isStrictRestrictions) {
        // 严格模式：强制将输出缩放到 imgW×imgH
        if (this.equal) {
          let scale = Math.min(W / this.imgW, H / this.imgH)
          W = W / scale
          H = H / scale
        } else {
          W = W / (W / this.imgW)
          H = H / (H / this.imgH)
        }
      }
      canvas.width = W
      canvas.height = H
      const ctx = canvas.getContext('2d')
      const Img = new Image()
      Img.src = url
      Img.onerror = () => {
        this.spinning = false
        this.$message.error('图片处理失败，请重试')
        this.$emit('error', new Error('Failed to load the image in downImg.'))
      }
      Img.onload = () => {
        ctx.drawImage(Img, 0, 0, W, H)
        const imgData = canvas.toDataURL(
          this.isNeedPng ? 'png' : 'image/jpeg',
          1
        )
        // 下载
        const saveFile = function(data, filename) {
          const saveLink = document.createElementNS(
            'http://www.w3.org/1999/xhtml',
            'a'
          )
          saveLink.href = data
          saveLink.download = filename
          const event = document.createEvent('MouseEvents')
          event.initMouseEvent(
            'click',
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          )
          saveLink.dispatchEvent(event)
        }

        // 如果需要下载
        const filename = 'image.' + type
        this.spinning = true
        if (this.isSaveImg) {
          saveFile(imgData, filename)
        }

        const base64ToBlob = function(base64Data) {
          const arr = base64Data.split(',')
          const fileType = arr[0].match(/:(.*?);/)[1]
          const bstr = atob(arr[1])
          let l = bstr.length
          const u8Arr = new Uint8Array(l)
          while (l--) {
            u8Arr[l] = bstr.charCodeAt(l)
          }
          return new Blob([u8Arr], {
            type: fileType
          })
        }
        const blobToFile = function(newBlob, fileName) {
          newBlob.lastModifiedDate = new Date()
          newBlob.name = fileName
          return newBlob
        }
        const blob = base64ToBlob(imgData)
        const file = blobToFile(blob, 'cover')

        // 如果需要上传
        if (this.isUploadImg) {
          this.uploadImg(file, { W, H })
        }
      }
    },

    // 图片上传
    async uploadImg(file, sizeObj) {
      let aliyunInfo = null

      this.spinning = true
      if (this.aliyunInfo && this.aliyunInfo.lifeTime > 30) {
        aliyunInfo = this.aliyunInfo
      } else {
        try {
          const { result } = await getAliyunInfo(this.$axios)
          aliyunInfo = result.aliyunInfo
        } catch (e) {
          this.spinning = false
        }
      }
      if (!this.spinning) return
      let endpoint = this.user.aliyunOssEndpoint
      let imgBucket = ''
      let hostUrl = this.circleAliyunOss.image.cdnHost
      if (this.uploadType === 'f038') {
        imgBucket = process.env.VUE_APP_F038_FILE_BUCKET
        hostUrl = process.env.VUE_APP_F038_FILE_HOST
        endpoint = process.env.VUE_APP_ENDPOINT
      } else {
        imgBucket = this.circleAliyunOss.image.bucket
      }
      this.bucket = imgBucket
      const client = await OssRequset(aliyunInfo, endpoint, imgBucket)

      if (client.status === 'error') {
        this.$emit('error')
        return this.clearPreviewImg()
      }
      const md5 = await getMd5(file)
      if (!md5) {
        this.$emit('error', 1)
        return this.clearPreviewImg()
      }
      const type = file.type
      const suff = type ? type.split('/')[1] : ''
      const _image = this.prefixPath + md5 + '.' + suff
      client
        .put(_image, file)
        .then(() => {
          const obj = {
            file,
            name: file.name,
            fileKey: _image,
            size: file.size,
            width: Math.round(sizeObj.W),
            height: Math.round(sizeObj.H),
            ratio:
              Math.ceil((Math.round(sizeObj.W) / Math.round(sizeObj.H)) * 100) /
              100,
            url: hostUrl + _image,
            originUrl: this.imgStr,
            opacity: 1
          }

          if (this.editIndex !== '') {
            this.$emit('edit', { ...obj, index: this.editIndex })
          } else {
            this.fileList.push(obj)
            this.$emit('upload', obj)
          }
          if (this.multiple && this.uploadNums > 1) {
            if (this.fileList.length >= this.uploadNums) {
              this.spinning = false
              this.uploadNums = 0
            }
          } else {
            this.spinning = false
            this.uploadNums = 0
          }
        })
        .catch(e => {
          this.spinning = false
          this.$emit('error', e)
        })
    },

    // 上传失败清除预览 图片
    clearPreviewImg() {
      this.$message.error('图片上传失败')
    },

    // 初始化打码界面
    async handleMosaicInit() {
      const { W, H, url } = await this.Draw()
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.id = 'mosaic-canvas'
      this.MosaicCtx = ctx
      this.MosaicCanvas = canvas
      // 默认马赛克
      this.currentMosaic = this.mosaicIcon.mosaic
      canvas.width = W
      canvas.height = H
      this.MosaicObj.W = W
      this.MosaicObj.H = H
      this.allMosaicList = []

      this.$el.querySelector('.mosaic-canvas-box').innerHTML = ''
      this.$el.querySelector('.mosaic-canvas-box').appendChild(canvas)

      canvas.addEventListener('mousedown', e => {
        if (!this.currentMosaic.id) return
        this.LastMosaicList = {
          uuid: '',
          name: '',
          scaling: 1,
          isDel: false,
          pos: []
        }
        this.continuousDraw = true
        this.handleAddMosaic(e)
      })
      document.documentElement.addEventListener('mouseup', () => {
        if (this.continuousDraw) {
          this.continuousDraw = false
          this.allMosaicList.push({
            ...this.LastMosaicList,
            ...{
              name: this.currentMosaic.name,
              uuid: createUuid()
            }
          })
          this.recoverMosaicList = []
          this.LastMosaicList = {
            uuid: '',
            name: '',
            scaling: 1,
            isDel: false,
            pos: []
          }
        }
      })
      canvas.addEventListener('mousemove', e => {
        if (this.continuousDraw) {
          this.handleAddMosaic(e)
        }
      })

      this.currentMosaicImg = url
      this.setMosaicIng = true
      // this.currentMosaic = {}
      this.resetAllMosaic()
    },

    // 打码
    handleAddMosaic(e) {
      const obj = {
        x: e.offsetX,
        y: e.offsetY,
        ...this.currentMosaic
      }

      if (
        this.LastMosaicList.pos.length &&
        Math.abs(
          this.LastMosaicList.pos[this.LastMosaicList.pos.length - 1].x - obj.x
        ) < 10 &&
        Math.abs(
          this.LastMosaicList.pos[this.LastMosaicList.pos.length - 1].y - obj.y
        ) < 10
      ) {
        return
      }

      const minX = 0
      const minY = 0
      const W = this.MosaicObj.W
      const H = this.MosaicObj.H

      let l = e.offsetX - this.currentMosaic.w / 2
      l = l < minX ? minX : l

      let t = e.offsetY - this.currentMosaic.w / 2
      t = t < minY ? minY : t

      const w =
        e.offsetX + this.currentMosaic.w / 2 > W
          ? e.offsetX + this.currentMosaic.w / 2 - W
          : this.currentMosaic.w

      const h =
        e.offsetY + this.currentMosaic.w / 2 > H
          ? e.offsetY + this.currentMosaic.w / 2 - H
          : this.currentMosaic.w

      obj.color = this.getMeanColor(
        this.MosaicCtx.getImageData(l, t, w, h).data
      )

      // 将对象添加到最后一次的序列中
      this.LastMosaicList.pos.push(obj)

      if (this.currentMosaic.id === 'mosaic') {
        this.MosaicCtx.fillStyle = obj.color
        this.MosaicCtx.fillRect(
          obj.x - this.currentMosaic.w / 2,
          obj.y - this.currentMosaic.w / 2,
          this.currentMosaic.w,
          this.currentMosaic.w
        )
      } else {
        // 即时画出马赛克
        this.MosaicCtx.drawImage(
          this.$el.querySelector('#' + obj.id),
          obj.x - this.currentMosaic.w / 2,
          obj.y - this.currentMosaic.h / 2,
          obj.w,
          obj.h
        )
      }
    },

    // 重绘所有马赛克
    resetAllMosaic() {
      const Img = new Image()
      Img.src = this.currentMosaicImg
      Img.onload = () => {
        this.currentMosaicImgDom = Img
        this.MosaicCtx.clearRect(0, 0, this.MosaicObj.W, this.MosaicObj.H)
        this.MosaicCtx.drawImage(Img, 0, 0, this.MosaicObj.W, this.MosaicObj.H)
        this.allMosaicList.forEach(mosaic => {
          if (mosaic.isDel) return
          mosaic.pos.forEach(v => {
            if (v.id === 'mosaic') {
              this.MosaicCtx.fillStyle = v.color
              this.MosaicCtx.fillRect(
                v.x - (v.w * mosaic.scaling) / 2,
                v.y - (v.w * mosaic.scaling) / 2,
                v.w * mosaic.scaling,
                v.w * mosaic.scaling
              )
            } else {
              this.MosaicCtx.drawImage(
                this.$el.querySelector('#' + v.id),
                v.x - (v.w * mosaic.scaling) / 2,
                v.y - (v.h * mosaic.scaling) / 2,
                v.w * mosaic.scaling,
                v.h * mosaic.scaling
              )
            }
          })
        })
      }
    },

    // 打码撤消
    handleDelMosaic() {
      if (!this.allMosaicList.length) return
      this.recoverMosaicList.push(this.allMosaicList.pop())
      this.resetAllMosaic()
    },

    // 打码恢复
    recoverMosaicLog() {
      if (!this.recoverMosaicList.length) return
      this.allMosaicList.push(this.recoverMosaicList.pop())
      this.resetAllMosaic()
    },

    // 获取平均色
    getMeanColor(colorList) {
      let R = 0
      let G = 0
      let B = 0
      let A = 0
      for (let i = 0; i < colorList.length; i += 4) {
        R += colorList[i]
        G += colorList[i + 1]
        B += colorList[i + 2]
        A += colorList[i + 3]
      }
      return `rgba(${R / (colorList.length / 4)},
      ${G / (colorList.length / 4)},
      ${B / (colorList.length / 4)},
      ${A / (colorList.length / 4)})`
    }
  }
}
